import {Component, OnInit} from '@angular/core';
import {StellenService} from '../stellen.service';
import {ActivatedRoute, Router} from '@angular/router';
import {TranslateService} from '@ngx-translate/core';

@Component({
    selector: 'app-stellenangebote',
    templateUrl: './stellenangebote.component.html',
    styleUrls: ['./stellenangebote.component.css']
})
export class StellenangeboteComponent implements OnInit {

    constructor(public stellenService: StellenService,
                private route: ActivatedRoute,
                private router: Router,
                private translate: TranslateService) {

        translate.setDefaultLang('de');
        translate.use(stellenService.lang);
    }

    codesystems: object = {};
    rawData: any = [];
    stellenangebote;

    stellenFilterArgs = {
        textFilter: '',
        standortFilter: '',
        abteilungFilter: '',
        typeFilter: '',
        spezialFilter: ''
    };


    locationFilterList: any = [];
    typeList = [];
    abteilungList = [];
    showSpinner = false;
    stellenGeladen = false;
    katalogeGeladen = false;

    ngOnInit() {
        window.scroll(0, 0);
        this.stellenGeladen = false;
        this.katalogeGeladen = false;
        this.setSpinner();
        if (this.stellenService.mandant && this.stellenService.mandant.length > 0) {
            this.stellenService.standortFilter = this.stellenService.mandant;
            this.stellenService.mandant = '';
        }
        this.stellenService.getStellenangebote(false, '').then((response) => {
            this.rawData = response;
            this.stellenangebote = this.rawData.map(x => Object.assign({}, x));

            this.stellenangebote.forEach(x => {
                const abteilungsArr = x.data.abteilungen;
                for (let i = 0; i <= abteilungsArr.length; i++) {
                    const current = abteilungsArr[i];
                    if (current != null && current != undefined && this.abteilungList.indexOf(current) === -1) {
                        this.abteilungList.push(abteilungsArr[i]);
                    }
                }

                x.description = x.description.substring(0, x.description.indexOf(',') + 2)
                    + x.description.substring(x.description.indexOf(' - ') + 2);
            });
            this.stellenGeladen = true;
            this.setSpinner();

        });
        this.stellenService.getCodesystems().then((response) => {
            this.codesystems = response;
            const meffertAll = {
                data: '100',
                label: 'Meffert AG'
            };
            this.locationFilterList.push(meffertAll);
            const mandanten = this.codesystems['Mandant'];
            for (let i = 0; i < mandanten.length; i++) {
                if (mandanten[i].label.indexOf('Meffert') === -1 &&
                    mandanten[i].label.indexOf(' - ') !== -1 &&
                    Number(mandanten[i].label.substring(0, mandanten[i].label.indexOf(' - '))).valueOf() <= 155) {
                    const newMandant = Object.assign({}, mandanten[i]);
                    newMandant.label = mandanten[i].label.substring(mandanten[i].label.indexOf(' - ') + 3);
                    this.locationFilterList.push(newMandant);
                }
            }

            this.typeList = [];
            const stellenarten = this.codesystems['Stellenart'];
            for (let i = 0; i < stellenarten.length; i++) {
                const stelle = stellenarten[i];
                const entry = {
                    label: stelle.label,
                    value: stelle.data
                };
                this.typeList.push(entry);
            }
            this.katalogeGeladen = true;
            this.ngOnInitAfterCodesystems();
        });
    }

    ngOnInitAfterCodesystems() {
        if (!this.stellenService.typeInitialised) {
            if (this.route.snapshot.routeConfig.path.toLowerCase() === 'ausbildung') {
                this.stellenService.typeFilter = 'Ausbildung';
            } else if (this.route.snapshot.routeConfig.path.toLowerCase() === 'stellen') {
                this.stellenService.typeFilter = 'Stellenangebot';
            }
            this.stellenService.typeInitialised = true;
        }
        this.filterStellen();
        this.setSpinner();
    }

    setSpinner(){
        if(this.stellenGeladen && this.katalogeGeladen){
            this.showSpinner = false;
        }else{
            this.showSpinner = true;
        }
    }

    filterStellen() {
        this.stellenFilterArgs.standortFilter = this.stellenService.standortFilter;
        this.stellenFilterArgs.abteilungFilter = this.stellenService.abteilungFilter;
        this.stellenFilterArgs.typeFilter = this.stellenService.typeFilter;
        this.stellenFilterArgs.textFilter = this.stellenService.textFilter;
    }

    checkKey(ev) {
        if (ev.key === 'Enter') {
            this.filterStellen();
        } else {
            return;
        }
    }
}
